module.exports = __webpack_public_path__ + "image/grb_green.svg";